(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-atc-button"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp-atc-bar]').forEach((bar) => {
    const realButton =
      document.querySelector('[data-testid="standalone-add-to-cart"]') ||
      document.querySelector('[ref="addToCartButton"]');
    if (!realButton || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(realButton);
  });

  document.querySelectorAll('[data-pdp-atc-trigger]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const realButton =
      document.querySelector('[data-testid="standalone-add-to-cart"]') ||
      document.querySelector('[ref="addToCartButton"]');
      if (realButton && !realButton.disabled) {
        realButton.click();
        return;
      }
      const scrollTarget =
        document.querySelector('[ref="mainVariantPicker"]') ||
        document.querySelector('variant-picker') ||
        realButton;
      if (scrollTarget) {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-brand-spotlight"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-video]').forEach((wrap) => {
    const video = wrap.querySelector('video');
    const toggle = wrap.querySelector('.pdp-brand-spotlight__video-toggle');
    const sync = () => { wrap.classList.toggle('is-paused', video.paused); toggle.setAttribute('aria-label', video.paused ? 'Video afspelen' : 'Video pauzeren'); };
    wrap.addEventListener('click', () => { if (video.paused) { video.play(); } else { video.pause(); } });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-upsell-products"] && !Shopify.designMode) return;
  try {
    
  // document.querySelectorAll('[data-set-form]').forEach((form) => {
  //   form.addEventListener('submit', async (event) => {
  //     event.preventDefault();
  //     const button = form.querySelector('[data-set-add]');
  //     const items = Array.from(form.querySelectorAll('input[name="items[][id]"]')).map((input) => ({ id: Number(input.value), quantity: 1 }));
  //     if (button) button.disabled = true;
  //     try {
  //       const response = await fetch('/cart/add.js', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  //         body: JSON.stringify({ items }),
  //       });
  //       const result = await response.json();
  //       if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart add failed');

  //       const currentCartItems = document.querySelector('cart-items-component');
  //       const sectionId = currentCartItems?.dataset.sectionId;
  //       if (sectionId) {
  //         const sectionsResponse = await fetch(`/?sections=${sectionId}`);
  //         const sections = await sectionsResponse.json();
  //         const parsedSection = new DOMParser().parseFromString(sections[sectionId], 'text/html');
  //         const updatedCartItems = parsedSection.querySelector('cart-items-component');
  //         if (updatedCartItems && currentCartItems) currentCartItems.replaceWith(updatedCartItems);
  //       }
  //       document.querySelector('.cart-drawer__dialog')?.classList.remove('cart-drawer--empty');
  //       document.querySelector('cart-drawer-component')?.open();
  //     } catch (error) {
  //       console.error('Unable to add set to cart:', error);
  //       form.submit();
  //     } finally {
  //       if (button) button.disabled = false;
  //     }
  //   });
  // });
  document.addEventListener('DOMContentLoaded', () => {
    const bundleForms = document.querySelectorAll('[data-set-form]');

    if (!bundleForms.length) {
      return;
    }

    bundleForms.forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[data-set-add]');

        const discountCode = form.dataset.setDiscountCode?.trim() || '';

        const bundleKey = form.dataset.setBundleKey?.trim() || '';

        const variantInputs = form.querySelectorAll('input[name="items[][id]"]');

        const bundleKeyInputs = form.querySelectorAll('input[name="items[][properties][_bundle_key]"]');

        if (!variantInputs.length) {
          console.error('Bundle: No variants found.');
          return;
        }

        const items = Array.from(variantInputs).map((input, index) => {
          const currentBundleKey = bundleKeyInputs[index]?.value || bundleKey;

          return {
            id: Number(input.value),
            quantity: 1,
            properties: {
              _bundle_key: currentBundleKey,
            },
          };
        });

        if (button) {
          button.disabled = true;
        }

        try {
          /*
           * STEP 1
           * Add both bundle products to cart.
           */
          const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: items,
            }),
          });

          const addResult = await addResponse.json();

          if (!addResponse.ok || addResult.status) {
            throw new Error(addResult.description || addResult.message || 'Unable to add bundle to cart.');
          }

          /*
           * STEP 2
           * Apply discount code from Metaobject.
           */
          if (discountCode) {
            const discountResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                discount: discountCode,
              }),
            });

            const discountResult = await discountResponse.json();

            if (!discountResponse.ok || discountResult.status) {
              console.warn('Bundle discount could not be applied:', discountResult);
            } else {
              console.log('Bundle discount applied:', discountCode);
            }
          }

          /*
           * STEP 3
           * Refresh cart drawer.
           */
          const currentCartItems = document.querySelector('cart-items-component');

          const sectionId = currentCartItems?.dataset.sectionId;

          if (sectionId) {
            const sectionsResponse = await fetch(`/?sections=${sectionId}`);

            const sections = await sectionsResponse.json();

            const sectionHtml = sections[sectionId];

            if (sectionHtml) {
              const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');

              const updatedCartItems = parsedSection.querySelector('cart-items-component');

              if (updatedCartItems && currentCartItems) {
                currentCartItems.replaceWith(updatedCartItems);
              }
            }
          }

          /*
           * STEP 4
           * Open existing cart drawer.
           */
          const cartDrawer = document.querySelector('cart-drawer-component');

          if (cartDrawer) {
            cartDrawer.open();
          }
        } catch (error) {
          console.error('Bundle add-to-cart error:', error);
        } finally {
          if (button) {
            button.disabled = false;
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
